import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import InputBox from "../../../FormElement/InputBox";
import { ProjectsLocationsSearchParams } from "../hooks";

import "./styles.scss";

interface IFilterSelectProps {
  searchParams: ProjectsLocationsSearchParams;
  setSearchParams: React.Dispatch<
    React.SetStateAction<ProjectsLocationsSearchParams>
  >;
}

export const FilterSelect: React.FunctionComponent<IFilterSelectProps> = (
  props
) => {
  const { searchParams, setSearchParams } = props;
  const { t } = useTranslation();
  const tFilter = (key: string) =>
    t(`projectManagementPage.projectFacilitiesList.filter.${key}`);

  const [inputValue, setInputValue] = useState(
    searchParams.location_name ?? ""
  );

  useEffect(() => {
    setInputValue(searchParams.location_name ?? "");
  }, [searchParams.location_name]);

  const hasActiveFilter = (searchParams.location_name ?? "").trim() !== "";

  const handleApply = () => {
    setSearchParams((sp) => ({
      ...sp,
      location_name: inputValue.trim() || undefined,
      offset: 0
    }));
  };

  const handleClear = () => {
    setInputValue("");
    setSearchParams((sp) => ({
      ...sp,
      location_name: undefined,
      offset: 0
    }));
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleApply();
    }
  };

  return (
    <div className="project-facilities-list-filter-select">
      <InputBox
        type="text"
        isSearch
        placeholder={tFilter("search_placeholder")}
        value={inputValue}
        onChange={(value) => setInputValue(value)}
        onKeyPress={handleKeyPress}
      />
      <button
        type="button"
        className="project-facilities-list-filter-select-button btn btn-border"
        onClick={handleApply}
      >
        {tFilter("apply")}
      </button>
      {hasActiveFilter && (
        <button
          type="button"
          className="project-facilities-list-filter-select-button btn btn-border btn-border-red"
          onClick={handleClear}
        >
          {tFilter("clear")}
        </button>
      )}
    </div>
  );
};
